import React, { useEffect, useState } from "react";
import profileBanner from "../../Assets/images/profile-bnr.webp";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import tableImg from "../../Assets/images/table-img.png";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import { decodeID, encodeID, getDate, getDateFormatData, getPriceHelper, setDateFormat } from "../../utils/Helper";
import FrontLoader from "../layout/FrontLoader";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
import { PAGINATION, StorageConstant, VALIDATION_MESSAGE } from '../../constants/Constants'
import { Modal } from "react-bootstrap";
import CheckOutModal from "../../Modal/CheckOutModal";
import AddressChangeMessage from "../../Modal/AddressChangeMessage";
import AddressChange from "../../Modal/AddressChange";
import SuccessModal from "../../Modal/SuccessModal";
import NewAddress from "../../Modal/NewAddress";
import ChatModal from "../../Modal/ChatModal";
import HistoryModal from "../../Modal/HistoryModal";
import { LanguageConstants } from "../../constants/LanguageConstants";
import MessageHistoryModal from "../../Modal/MessageHistoryModal";

function MyQuotation() {
    const quotationList = useMakeRequest()
    const quotationReject = useMakeRequest()
    const [data, setData] = useState([])
    const [status, setStatus] = useState('')
    const [search, setSearch] = useState('')
    const [searchStatus, setSearchStatus] = useState(false)
    const [addressMessageShow, setAddressMessageShow] = useState(false)
    const [checkOutShow, setCheckOutShow] = useState(false)
    const [addressChangeShow, setAddressChangeShow] = useState(false)
    const [paymentshow, setPaymentshow] = useState(false)
    const [chatshow, setChatshow] = useState(false)
    const [chatData, setChatData] = useState({})
    const [historyshow, setHistoryshow] = useState(false)
    const [historyData, setHistoryData] = useState({})

    const [pagination, setPagination] = useState<any>({ pageIndex: PAGINATION?.PAGE, pageSize: PAGINATION?.PAGESIZE });
    const [newAddress, setNewAddress] = useState(false)
    const [messgaeShow , setMessageShow] = useState(false)



    const [checkOutdata, setCheckOutdata] = useState({})
    const [start_date, setStartDate] = useState<any>('')
    const [end_date, setEndDate] = useState<any>('')
    const formRef = useRef<HTMLFormElement>(null);
    const navigate = useNavigate()
    const [currency, setCurrency] = useState<any>({type:"PHP" , Index:'0'})


    useEffect(() => {
        const payload = {
            status: status,
            start_date: setDateFormat(start_date),
            end_date: setDateFormat(end_date),
            search: search?.trim(),
            page: pagination.pageIndex,
            pageSize: pagination.pageSize,
        }
        quotationList.makeRequest({ payload, url: ApiConstants?.QuotesList, toastStatus: false })
    }, [status, searchStatus, quotationReject?.status, pagination])
    useEffect(() => {
        if (quotationList?.status) {
            setData(quotationList?.data?.data?.rows)
        }
    }, [quotationList?.status])

    const getTaxValue = (e: any) => {
        if (e?.tax_amount && e?.total_amount) {
            const total = Number(e?.total_shipping_price) + Number(e?.total_product_price) + Number(e?.other_charges)
            const taxValue = (total * e?.tax_amount) / 100;
            return `${taxValue.toFixed(2)}`;
        } else {
            return '$ 0.00';
        }
    };


    const handleStartDateInput = (e: any) => {
        setStartDate(e)
    }

    const handleEndDateInput = (e: any) => {
        setEndDate(e)
    }

    // search data 
    const handleSearch = (e: any) => {
        e.preventDefault()
        setSearchStatus(!searchStatus)
    }
    //  reset search filter data 
    const handleReset = () => {
        if (formRef.current) {
            formRef.current.reset();
        }
        setStartDate('')
        setEndDate('')
        setSearch('')
        setSearchStatus(!searchStatus)
    }

    // naviagate to view-quotation page 
    const hanldeNaviagate = (e: any) => {
        navigate(`/view-quotation/${e?.quotation_id}`)
    }

    // Reject Quotation 
    const handelReject = (e: any) => {
        Swal.fire({
            title: LanguageConstants?.ARE_YOU_SURE,
            text: LanguageConstants?.REJECT_QUTO,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonColor: '#31CE36',
            cancelButtonColor: '#d33',
            showDenyButton: true,
            denyButtonText: 'No',
            confirmButtonText: 'Yes',
        }).then(async (result: any) => {
            if (result.isConfirmed) {
                const payload = {
                    quotation_id: e?.quotation_id
                }
                quotationReject.makeRequest({ payload, url: ApiConstants?.QuotesStatusUpdate, toastStatus: true })
            }
        });
    }

    // close checkout modal 
    const CloseCheckOutModal = () => {
        setCheckOutShow(false)
    }
    // Close Address Message Modal 
    const CloseAddressMessageModal = () => {
        setAddressMessageShow(false)
    }
    // Open checkout modal
    const handelCheckout = (e: any) => {
        setCheckOutShow(true)
        setCheckOutdata(e)
    }
    // Pagination  more data 
    const handleIncreasePageSize = () => {
        setPagination((prevState: any) => ({
            ...prevState,
            pageSize: prevState.pageSize + 10
        }));
    };
    // clso new Address modal
    const handleClsoNewAddressModal = () => {
        setNewAddress(false)
    }

    // open chat popu modal
    const handleOpenChat = (e: any) => {
        setChatData(e)
        setChatshow(true)
    }

    // open history modal show
    const handleHistory = (e: any) => {
        setHistoryData(e)
        setHistoryshow(true)
    }

    // open message history modal show
    const handleMessageHistory = (e: any) => {
        setHistoryData(e)
        setMessageShow(true)
    }

    // naviagate to history-quotation page 
    const NaviagateHistory = (e: any) => {
        navigate(`/history/${encodeID(e?.quotation_id)}`)
    }

const ConvertPrice = (index: any, shipping_amount: any, totalamount: any, tax: any) => {
        setCurrency((prevCurrency:any) => ({...prevCurrency,type:currency?.type == "USD" ? "PHP" : "USD" , Index: index,}));
        if (currency.type == "PHP") {
           if(shipping_amount && totalamount){
            let newDataArr: any = [...data];
            const getPrice = localStorage.getItem('currencyValue')
            const priceValue = decodeID(getPrice)
            newDataArr = newDataArr[index] = {
                ...newDataArr[index],
                total_shipping_price: Number(shipping_amount * priceValue).toFixed(2),
                total_amount: Number(totalamount * priceValue).toFixed(2),
                other_charges: Number(tax * priceValue).toFixed(2),
                old_total_shipping_price: Number(shipping_amount).toFixed(2),
                old_total_amount: Number(totalamount).toFixed(2),
                old_other_charges: Number(tax).toFixed(2)
            }
            console.log(newDataArr)
            data.splice(index, 1)
            const newNumbers = [...data.slice(0, index), newDataArr, ...data.slice(index)];
            //@ts-ignore
            setData(newNumbers)
           }else{
           return
           } 
        } else {
            if(shipping_amount && totalamount){
                let newDataArr: any = [...data];
                newDataArr = newDataArr[index] = {
                    ...newDataArr[index],
                    total_shipping_price: Number(newDataArr[index].old_total_shipping_price ? newDataArr[index].old_total_shipping_price : newDataArr[index].total_shipping_price).toFixed(2),
                    total_amount: Number(newDataArr[index].old_total_amount ? newDataArr[index].old_total_amount : newDataArr[index].total_amount).toFixed(2),
                    other_charges: Number(newDataArr[index].old_other_charges ? newDataArr[index].old_other_charges : newDataArr[index].other_charges).toFixed(2),
                }
                data.splice(index, 1)
                const newNumbers = [...data.slice(0, index), newDataArr, ...data.slice(index)];
                //@ts-ignore
                setData(newNumbers) 
            }else{
                return
            }
        }
    }





    return (
        <>
            {(quotationList?.loading || quotationReject.loading) ? <FrontLoader /> : null}
            <main>
                {/* top banner section start */}
                <section
                    className="main-banner small-banner"
                    style={{ background: `url(${profileBanner}) center/cover` }}
                >
                    <div className="container">
                        <h1 className="small-banner-heading">{LanguageConstants?.MYOUESTION}</h1>
                        <nav className="com-breadcrumb" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/profile">{LanguageConstants?.PROFILE}</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">{LanguageConstants?.MYOUESTION}</li>
                            </ol>
                        </nav>
                    </div>
                </section>
                {/* top banner section end  */}
                <div className="footer-space">
                    <div className="container">
                        <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        ...
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                        <button type="button" className="btn btn-primary">Save changes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <form ref={formRef} onSubmit={handleSearch}>
                            <div className="top-bar-area">
                                <h2 className="title-1 mb-2">{LanguageConstants?.QUOTATIONSLIST}</h2>
                                <div className="top-bar-right">
                                    <div className="top-bar-date">
                                        <label>{LanguageConstants?.FROM}</label>
                                        <DatePicker
                                            className='form-control'
                                            placeholderText={LanguageConstants?.DATETYPE}
                                            timeFormat="MM DD YYYY"
                                            selected={start_date}
                                            onKeyDown={(e: any) => e.preventDefault()}
                                            onChange={handleStartDateInput}
                                        />
                                    </div>
                                    <div className="top-bar-date">
                                        <label>{LanguageConstants?.TO}</label>
                                        <DatePicker
                                            className='form-control'
                                            placeholderText={LanguageConstants?.DATETYPE}
                                            timeFormat="MM DD YYYY"
                                            disabled={start_date ? false : true}
                                            minDate={start_date}
                                            selected={end_date}
                                            onKeyDown={(e: any) => e.preventDefault()}
                                            onChange={handleEndDateInput}
                                        />
                                    </div>
                                    <div className="top-bar-search">
                                        <i className="icon-search"></i>
                                        <input type="text" className="form-control" placeholder={LanguageConstants?.MESSAGEDATA} onChange={(e: any) => setSearch(e?.target?.value)} />

                                    </div>
                                    <button type="submit" className="round-btn" onClick={(e: any) => handleSearch(e)} >{LanguageConstants?.Filter}</button>
                                    <button className="round-btn round-btn-outline" onClick={() => handleReset()} >{LanguageConstants?.Reset}</button>
                                </div>
                            </div>
                        </form>

                        <div className="quotation-box">
                            <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation" onClick={() => setStatus('')} >
                                    <button className="nav-link active" id="pills-all-tab" data-bs-toggle="pill" data-bs-target="#pills-all" type="button" role="tab" aria-controls="pills-all" aria-selected="true">{LanguageConstants?.ALL}</button>
                                </li>
                                <li className="nav-item" role="presentation" onClick={() => setStatus('0')}>
                                    <button className="nav-link" id="pills-pending-tab" data-bs-toggle="pill" data-bs-target="#pills-pending" type="button" role="tab" aria-controls="pills-pending" aria-selected="false">{LanguageConstants?.PENDING}</button>
                                </li>
                                <li className="nav-item" role="presentation" onClick={() => setStatus('1')}>
                                    <button className="nav-link" id="pills-progress-tab" data-bs-toggle="pill" data-bs-target="#pills-progress" type="button" role="tab" aria-controls="pills-progress" aria-selected="false">{LanguageConstants?.Progress}</button>
                                </li>
                                <li className="nav-item" role="presentation" onClick={() => setStatus('2')}>
                                    <button className="nav-link" id="pills-approved-tab" data-bs-toggle="pill" data-bs-target="#pills-approved" type="button" role="tab" aria-controls="pills-approved" aria-selected="false">{LanguageConstants?.APPROVED}</button>
                                </li>
                                <li className="nav-item" role="presentation" onClick={() => setStatus('3')}>
                                    <button className="nav-link" id="pills-rejected-tab" data-bs-toggle="pill" data-bs-target="#pills-rejected" type="button" role="tab" aria-controls="pills-rejected" aria-selected="false">{LanguageConstants?.REJECT}</button>
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-all" role="tabpanel" aria-labelledby="pills-all-tab">
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    {/* <th>{LanguageConstants?.SNO}</th> */}
                                                    <th className="text-center" >{LanguageConstants?.QUOTATIONID}</th>
                                                    <th className="text-center">{LanguageConstants?.DATE}</th>
                                                    {/* <th>Image</th> */}
                                                    {/* <th>Product Name</th> */}
                                                    <th className="text-center">{LanguageConstants?.STATUS}</th>
                                                    {/* <th>{LanguageConstants?.SHIPPING} <br /> {LanguageConstants?.PRICE}</th> */}
                                                    {/* <th>{LanguageConstants?.OTHER} <br /> {LanguageConstants?.CHARGES}</th> */}
                                                    {/* <th>{LanguageConstants?.TAX}<br /> {LanguageConstants?.AMOUNT}</th> */}
                                                    <th className="text-center" > {LanguageConstants?.TOTAL} {LanguageConstants?.NET}</th>
                                                    <th className="text-center">{LanguageConstants?.ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.length > 0 ? data.map((res: any, i: any) => (
                                                    <tr key={i}>
                                                        {/* <td className="text-center">{i + 1}</td> */}
                                                        <td className="text-center">{res?.quotation_id}</td>
                                                        <td className="text-center">{getDate(res?.created_at)}</td>
                                                        {res?.status == '0' ? <td className="text-center blue-text">{LanguageConstants?.PENDING}</td> : res?.status == '1' ? <td className="text-center yellow-text">{LanguageConstants?.Progress}</td> : res?.status == '2' ? <td className="text-center approved-text">{LanguageConstants?.APPROVED}</td> : <td className="text-center red-text">{LanguageConstants?.REJECT}</td>}
                                                        {/* <td className="text-center">{res?.total_shipping_price ? `${"$"} ${getPriceHelper(res?.total_shipping_price)} ${currency?.Index == i && currency?.type == "USD" ? "CLP" : ''}` : '-'}</td> */}
                                                        {/* <td className="text-center">{res?.other_charges ? `${"$"} ${getPriceHelper(res?.other_charges)} ${currency?.Index == i && currency?.type == "USD" ? "CLP" : ''}` : '-'}</td> */}
                                                        {/* <td className="text-center">{res?.tax_amount ?  "$" : null} {getPriceHelper(getTaxValue(res))} {currency?.Index == i && currency?.type == "USD" ? "CLP" : ''}</td> */}
                                                        <td className="text-center">{(res?.total_amount && res?.status != 0)  ? `${currency?.Index == i && currency?.type == "USD" ? "€" : '$'}${getPriceHelper(res?.total_amount)}` : '$0.00'}</td>
                                                        <td className="text-center">
                                                            <div className={res?.status == '0' ? "table-action-wrap stop-action" : res?.status == '2' || res?.status == "3" || res?.history_detail == null ? "table-action-wrap stop-action" : "table-action-wrap"}>
                                                            <button className="table-action" onClick={() => hanldeNaviagate(res)}  ><i className="icon-view-all"></i>
                                                                    <span className="action-tooltip">{LanguageConstants?.VIEW}</span>
                                                                </button>
                                                                <button className={res?.history_detail == null ? "table-action correct-action disabled-action" : "table-action"} disabled={res?.history_detail == null ? true : false} onClick={() => NaviagateHistory(res)} >
                                                                    <i className="icon-history"></i>
                                                                    <span className="action-tooltip ">{LanguageConstants?.PRODUCT_HISTORY}</span>
                                                                </button>
                                                                {/* <button onClick={() => ConvertPrice(i, res?.total_shipping_price, res?.total_amount, res?.other_charges)} className="table-action"><i className="icon-dollar-and-yen"></i>
                                                                    <span className="action-tooltip">{LanguageConstants?.EXCHANGE}</span>
                                                                </button> */}
                                                                <button className="table-action" onClick={() => handleMessageHistory(res)} ><i className="icon-chat" style={{color:'green'}} ></i>
                                                                    <span className="action-tooltip">{LanguageConstants?.MESSAGE}</span>
                                                                </button>
                                                                {/* <button className={res?.parent_id == null ? "table-action correct-action disabled-action" : "table-action"} disabled={res?.parent_id == null ? true : false} onClick={() => handleHistory(res)} ><i className="icon-time"></i>
                                                                    <span className="action-tooltip">{LanguageConstants?.HISTORY}</span>
                                                                </button> */}
                                                               
                                                                {/* <button className="table-action correct-action" onClick={() => handelCheckout(res)}><i className="icon-accept"></i>
                                                                    <span className="action-tooltip">{LanguageConstants?.Approve}</span>
                                                                </button>
                                                                <button className="table-action close-action" onClick={() => handelReject(res)} ><i className="icon-close"></i>
                                                                    <span className="action-tooltip">{LanguageConstants?.Reject}</span>
                                                                </button> */}

                                                            </div>
                                                        </td>
                                                    </tr>
                                                )) :
                                                    <tr>
                                                        <td colSpan={20}>
                                                            <p className="text-center mt-3">{LanguageConstants?.DATANOTFOUND}</p>
                                                        </td>
                                                    </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {quotationList?.data?.data?.count > 10 && quotationList?.data?.data?.count > pagination.pageSize ?
                                        <button className="round-btn mt-4" onClick={() => handleIncreasePageSize()} >More</button>
                                        : null}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </main>
            {/* Check Out Modal start */}
            <Modal show={checkOutShow}>
                <CheckOutModal handleClose={CloseCheckOutModal} data={checkOutdata} setAddressMessageShow={setAddressMessageShow} setPaymentshow={setPaymentshow} />
            </Modal>
            {/* Check Out Modal End */}


            {/* Address change message start */}
            <Modal show={addressMessageShow}>
                <AddressChangeMessage handleClose={CloseAddressMessageModal} setAddressChangeShow={setAddressChangeShow} />
            </Modal>
            {/* Address change message End */}


            {/* Address change  start */}
            <Modal show={addressChangeShow}  >
                <AddressChange setAddressChangeShow={setAddressChangeShow} data={checkOutdata} setNewAddress={setNewAddress} />
            </Modal>
            {/* Address change  End */}

            {/* Add new address  start */}
            <Modal show={newAddress}  >
                <NewAddress handleClose={handleClsoNewAddressModal} data={checkOutdata} setNewAddress={setNewAddress} />
            </Modal>
            {/* Add new address  End */}

            {/* Paymnet success   start */}
            <Modal show={paymentshow}  >
                <SuccessModal />
            </Modal>
            {/* Paymnet success  End */}

            {/* Chat Modal  start */}
            <Modal show={chatshow} >
                <ChatModal data={chatData} setChatshow={setChatshow} />
            </Modal>
            {/* Chat Modal  end */}


            {/* History modal start */}
            <Modal show={historyshow} >
                <HistoryModal data={historyData} setHistoryshow={setHistoryshow} />
            </Modal>
            {/* History modal end */}


              {/* Message History modal start */}
            <Modal show={messgaeShow} >
                <MessageHistoryModal data={historyData} setHistoryshow={setMessageShow} />
            </Modal>
            {/* Message History modal end */}




        </>
    )
}

export default MyQuotation